import React from 'react';
import PropTypes from 'prop-types';

class Pointer extends React.Component {
    render() {
        return <div className="pointer" />;
    }
}

Pointer.propTypes = {};

Pointer.defaultProps = {};

export default Pointer;
